import React from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { Button } from '../../../components/Button/Button'

interface MeetingLevelConsentConfirmModalProps {
  show: boolean
  onConfirm: () => void
  onHide: () => void
  targetOption: 'everyMeeting' | 'perClient'
}

export const MeetingLevelConsentConfirmModal: React.FC<MeetingLevelConsentConfirmModalProps> = ({ show, onConfirm, onHide, targetOption }) => {
  const title = targetOption === 'everyMeeting' ? 'Require consent each meeting?' : 'Require consent once per client?'
  const description =
    targetOption === 'everyMeeting'
      ? 'Consent needs to be captured at every meeting to access them. Existing consent data are kept but only apply to the meeting they were captured on.'
      : "Clients will only need to give consent once. Their consent stays valid until it's revoked."

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={
        <div className='d-flex flex-column gap-4 text-center'>
          <h4 className='zocks-text-gray-900'>{title}</h4>
          <p className='paragraph-medium zocks-text-gray-900 mb-0'>{description}</p>
        </div>
      }
      footer={
        <div className='d-flex flex-grow-1 gap-3 align-items-center'>
          <Button variant='secondary' className='flex-grow-1' onClick={onHide}>
            Cancel
          </Button>
          <Button variant='primary' className='flex-grow-1' onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      }
      centered
    />
  )
}
